(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let activeTrigger = null;

  const getGallery = (element) => element.closest('media-gallery');

  const setActiveIndexItem = (gallery, mediaId) => {
    if (!gallery || !mediaId) return;

    const index = gallery.querySelector('.product-gallery-index');
    if (!index) return;

    index.querySelectorAll('.product-gallery-index__item').forEach((item) => {
      item.classList.toggle(
        'product-gallery-index__item--active',
        item.querySelector(`[data-target="${mediaId}"]`) !== null
      );
    });
  };

  const openIndex = (trigger) => {
    if (!mobileQuery.matches) return;

    const gallery = getGallery(trigger);
    const index = gallery?.querySelector(`#${trigger.getAttribute('aria-controls')}`);
    const dialog = index?.querySelector('.product-gallery-index__dialog');
    if (!gallery || !index || !dialog) return;

    activeTrigger = trigger;
    const activeMedia = gallery.querySelector('[id^="GalleryViewer"] [data-media-id].is-active');
    setActiveIndexItem(gallery, activeMedia?.dataset.mediaId);

    index.hidden = false;
    document.body.classList.add('product-gallery-index-open');
    dialog.focus({ preventScroll: true });
  };

  const closeIndex = (index) => {
    if (!index || index.hidden) return;

    index.hidden = true;
    document.body.classList.remove('product-gallery-index-open');
    activeTrigger?.focus({ preventScroll: true });
    activeTrigger = null;
  };

  const setupIntentAwareSwipe = (gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const slider = viewer?.querySelector('.product__media-list.slider--mobile');
    if (!viewer || !slider) return;

    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let intent = null;

    slider.addEventListener(
      'touchstart',
      (event) => {
        if (!mobileQuery.matches || event.touches.length !== 1) return;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startScrollLeft = slider.scrollLeft;
        intent = null;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      (event) => {
        if (!mobileQuery.matches || event.touches.length !== 1) return;

        const deltaX = event.touches[0].clientX - startX;
        const deltaY = event.touches[0].clientY - startY;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        if (!intent && Math.max(absX, absY) > 8) {
          intent = absX > absY * 1.35 ? 'horizontal' : 'vertical';
        }

        if (intent !== 'horizontal') return;

        event.preventDefault();
        slider.scrollLeft = startScrollLeft - deltaX;
      },
      { passive: false }
    );

    slider.addEventListener(
      'touchend',
      (event) => {
        if (!mobileQuery.matches || intent !== 'horizontal') return;

        const changedTouch = event.changedTouches[0];
        const deltaX = changedTouch.clientX - startX;
        const sliderItemOffset =
          viewer.sliderItemOffset ||
          viewer.sliderItemsToShow?.[1]?.offsetLeft - viewer.sliderItemsToShow?.[0]?.offsetLeft ||
          slider.clientWidth;
        const currentPage = viewer.currentPage || Math.round(startScrollLeft / sliderItemOffset) + 1;
        const threshold = Math.min(90, sliderItemOffset * 0.22);
        let targetPage = currentPage;

        if (Math.abs(deltaX) > threshold) {
          targetPage = deltaX < 0 ? currentPage + 1 : currentPage - 1;
        }

        targetPage = Math.max(1, Math.min(targetPage, viewer.totalPages || viewer.sliderItemsToShow?.length || 1));
        viewer.setSlidePosition((targetPage - 1) * sliderItemOffset);
        intent = null;
      },
      { passive: true }
    );
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.product-gallery-index-trigger');
    if (trigger) {
      event.preventDefault();
      openIndex(trigger);
      return;
    }

    const closeButton = event.target.closest('.product-gallery-index__close');
    if (closeButton) {
      event.preventDefault();
      closeIndex(closeButton.closest('.product-gallery-index'));
      return;
    }

    const indexButton = event.target.closest('[data-gallery-index-item]');
    if (indexButton) {
      event.preventDefault();
      const gallery = getGallery(indexButton);
      const mediaId = indexButton.dataset.target;
      gallery?.setActiveMedia?.(mediaId, false);
      setActiveIndexItem(gallery, mediaId);
      closeIndex(indexButton.closest('.product-gallery-index'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openIndexModal = document.querySelector('.product-gallery-index:not([hidden])');
    if (openIndexModal) closeIndex(openIndexModal);
  });

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    viewer?.addEventListener('slideChanged', (event) => {
      setActiveIndexItem(gallery, event.detail.currentElement?.dataset.mediaId);
    });
    setupIntentAwareSwipe(gallery);
  });
})();
